import React, { useEffect, useState } from "react";
import Logo from "./assets/icons/Logo.svg";
import LogoDerma from "./assets/icons/LogoDerma.png";
import HappyEmpty from "./assets/icons/review-us/HappyEmpty.svg";
import HappyFilled from "./assets/icons/review-us/HappyFilled.svg";
import SadEmpty from "./assets/icons/review-us/SadEmpty.svg";
import SadFilled from "./assets/icons/review-us/SadFilled.svg";
import NeutralEmpty from "./assets/icons/review-us/NeutralEmpty.svg";
import NeutralFilled from "./assets/icons/review-us/NeutralFilled.svg";

const ENDPOINT =
  "https://script.google.com/macros/s/AKfycbzq-fG3-U77sCs-Hpyk5cj1l3BtUG98P-rM30FK8lKqo4t8_bfImAAkRE2Od0SGXmpn/exec";

// Each center has its own logo and questions. The `branch` key is sent with
// every response so the Apps Script can write it to that center's sheet.
const CENTERS = {
  medical: {
    logo: Logo,
    website: "https://www.telescopecenter.com/",
    name: "مركز تلسكوب الطبي",
    pageTitle: "استبيان مركز تلسكوب الطبي",
    questions: [
      "ما تقييمك لتعامل موظفي الاستقبال معك من حيث اللباقة وسرعة إنجاز إجراءات التسجيل؟",
      "ما تقييمك لمدة الانتظار من وقت وصولك حتى دخولك إلى الطبيب؟",
      "ما تقييمك لسرعة استجابة الكادر الطبي والتمريضي عند طلبك لهم أو حاجتك إليهم؟",
      "ما تقييمك لوضوح المعلومات التي قدمت لك عن حالتك الصحية وخيارات العلاج المناسبة لها؟",
      "ما تقييمك لوضوح شرح الكادر الطبي لما تحتاجه بعد مغادرتك المركز، مثل طريقة استخدام القطرات، والعناية بالعين في المنزل، ومواعيد المراجعة؟",
      "ما تقييمك لفريق فحص النظر من حيث الدقة وحسن التعامل؟",
      "ما تقييمك للخدمات المقدمة في قسم النظارات من حيث جودة الخدمة وتنوع الخيارات والمساعدة في الاختيار؟",
      "ما تقييمك للخدمات المقدمة في الصيدلية من حيث توفر الأدوية وشرح طريقة استخدامها؟",
      "ما تقييمك لنظافة المركز بشكل عام، بما في ذلك العيادات وغرف الانتظار ودورات المياه؟",
      "ما تقييمك لخدمة اصطفاف السيارات من حيث توفر المواقف وسهولة الوصول إلى المركز؟",
      "ما مدى رضاك العام عن تجربتك في المركز؟",
      "ما مدى احتمال أن توصي أقاربك وأصدقاءك بالعلاج في المركز؟",
    ],
  },
  derma: {
    logo: LogoDerma,
    website: "https://www.telescopecenter.com/",
    name: "تلسكوب ديرما",
    pageTitle: "استبيان تلسكوب ديرما",
    questions: [
      "ما تقييمك لتعامل موظفي الاستقبال معك من حيث اللباقة وسرعة إنجاز إجراءات التسجيل؟",
      "ما تقييمك لمدة الانتظار من وقت وصولك حتى دخولك إلى الطبيب؟",
      "ما تقييمك لسرعة استجابة الكادر الطبي والتمريضي عند طلبك لهم أو حاجتك إليهم؟",
      "ما تقييمك لوضوح المعلومات التي قدمت لك عن حالتك وخيارات العلاج او الاجراء المناسب؟",
      "ما تقييمك لوضوح المعلومات المقدمة من قبل الكادر الطبي للعناية اللازمة بعد مغادرتك المركز ومواعيد المراجعة؟",
      "ما تقييمك للكادر المختص بالإجراءات والجلسات العلاجية من حيث المهارة وحسن التعامل؟",
      "ما تقييمك لمدى وضوح شرح الإجراء أو الجلسة قبل البدء بها، بما في ذلك النتائج المتوقعة والآثار الجانبية المحتملة؟",
      "ما تقييمك للخدمات المقدمة في الصيدلية من حيث توفر الأدوية ومستحضرات العناية بالبشرة وشرح طريقة استخدامها؟",
      "ما تقييمك لنظافة المركز بشكل عام، بما في ذلك العيادات وغرف الإجراءات وغرف الانتظار ودورات المياه؟",
      "ما تقييمك لخدمة اصطفاف السيارات من حيث توفر المواقف وسهولة الوصول إلى المركز؟",
      "ما مدى رضاك العام عن تجربتك في المركز؟",
      "ما مدى احتمال أن توصي أقاربك وأصدقاءك بالعلاج في المركز؟",
    ],
  },
};

const QUESTION_COUNT = 12;

const emptyForm = () => ({
  ...Object.fromEntries(
    Array.from({ length: QUESTION_COUNT }, (_, i) => [`q${i + 1}`, ""])
  ),
  notes: "",
});

const t = {
  notesLabel: "هل لديك ملاحظات اضافية",
  notesPlaceholder: "ملاحظات",
  thankYou: "شكرا جزيلا لكم في المشاركة في تعبئة الاستبيان",
  submitButton: "إرسال",
  sending: "...يتم الارسال ",
  rateTitle: "يرجى التقييم",
  startButton: "البدء",
  successAlert: "تم استلام الاستبيان بنجاح",
  failedAlert: "فشل الإرسال.",
  errorAlert: "حدث خطأ أثناء إرسال الاستبيان.",
};

// The center comes from the URL path: /derma shows the Derma survey and / the
// Medical Center survey. Any other path is replaced with / in the address bar.
const getCenterFromPath = () => {
  const path = window.location.pathname.replace(/\/+$/, "").toLowerCase();
  if (path === "/derma") return "derma";
  if (path !== "") window.history.replaceState(null, "", "/");
  return "medical";
};

export default function App() {
  const [center] = useState(getCenterFromPath);
  const selectedCenter = CENTERS[center];

  useEffect(() => {
    document.title = selectedCenter.pageTitle;
  }, [selectedCenter]);

  const [selectedFaces, setSelectedFaces] = useState({});
  const [startedRate, setstartedRate] = useState(false);
  const [formData, setFormData] = useState(emptyForm);
  const [isLoading, setisLoading] = useState(false);

  const toggleFace = (slideIndex, faceIndex) => {
    const faceLabels = {
      1: "sad",
      2: "neutral",
      3: "happy",
    };

    const currentSelection = selectedFaces[slideIndex];
    const newSelection = currentSelection === faceIndex ? null : faceIndex;

    setSelectedFaces((prev) => ({
      ...prev,
      [slideIndex]: newSelection,
    }));

    setFormData((prev) => ({
      ...prev,
      [`q${slideIndex + 1}`]: newSelection ? faceLabels[newSelection] : "",
    }));
  };

  const getFaceIcon = (slideIndex, faceIndex, emptyIcon, filledIcon) => {
    return selectedFaces[slideIndex] === faceIndex ? filledIcon : emptyIcon;
  };

  const getFaceClass = (slideIndex, faceIndex) => {
    const selection = selectedFaces[slideIndex];
    const base =
      "cursor-pointer rounded-full transition duration-200 ease-out hover:scale-110 hover:-translate-y-0.5 hover:drop-shadow-md active:scale-95";
    if (selection === faceIndex) return `${base} scale-110 drop-shadow-md`;
    // Fade the other faces once one is picked, so the choice stands out.
    if (selection) return `${base} opacity-40 hover:opacity-100`;
    return base;
  };

  const handleSubmit = async () => {
    setisLoading(true);

    try {
      const urlEncodedData = new URLSearchParams({
        branch: center,
        ...formData,
      }).toString();
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: urlEncodedData,
      });

      const result = await res.json();

      if (result.result === "success") {
        alert(t.successAlert);
        window.location.href = selectedCenter.website;
      } else {
        alert(t.failedAlert);
      }
    } catch (err) {
      console.error(err);
      alert(t.errorAlert);
    } finally {
      setisLoading(false);
    }
  };

  return (
    <div dir="rtl" className="h-screen flex flex-col">
      {startedRate ? (
        <div className="flex flex-col mx-auto">
          <div className="mx-auto mt-10 mb-7">
            <img
              src={selectedCenter.logo}
              alt={selectedCenter.name}
              className="h-16 w-auto"
            />
          </div>

          {selectedCenter.questions.map((question, idx) => (
            <div
              key={idx}
              className="flex flex-col justify-center space-y-6 p-6 rounded-lg w-full max-w-md mb-10"
            >
              <h1 className="font-somarSemibold  text-lg">{question}</h1>

              <div className="flex rtl:space-x-reverse space-x-6">
                <img
                  src={getFaceIcon(idx, 1, SadEmpty, SadFilled)}
                  alt="Sad"
                  width={40}
                  height={40}
                  onClick={() => toggleFace(idx, 1)}
                  className={getFaceClass(idx, 1)}
                />
                <img
                  src={getFaceIcon(idx, 2, NeutralEmpty, NeutralFilled)}
                  alt="Neutral"
                  width={40}
                  height={40}
                  onClick={() => toggleFace(idx, 2)}
                  className={getFaceClass(idx, 2)}
                />
                <img
                  src={getFaceIcon(idx, 3, HappyEmpty, HappyFilled)}
                  alt="Happy"
                  width={40}
                  height={40}
                  onClick={() => toggleFace(idx, 3)}
                  className={getFaceClass(idx, 3)}
                />
              </div>
            </div>
          ))}

          <div className="flex flex-col justify-center space-y-5 p-6 rounded-lg w-full ">
            <h1 className="font-somarSemibold text-lg">{t.notesLabel}</h1>

            <textarea
              rows={7}
              className="border rounded-lg font-somarRegular p-3"
              placeholder={t.notesPlaceholder}
              value={formData.notes || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  notes: e.target.value,
                }))
              }
            />
          </div>

          <div className="flex flex-col items-center justify-center space-y-6 mt-10 p-6 rounded-lg w-full ">
            <h1 className="font-somarSemibold text-center text-lg">
              {t.thankYou}
            </h1>
            <button
              onClick={() => {
                if (!isLoading) handleSubmit();
              }}
              className={`${
                isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-[#B29566]"
              } flex font-somarSemibold  rounded-xl p-2 px-24 lg:px-32 text-white`}
            >
              {isLoading ? t.sending : t.submitButton}

              {isLoading && (
                <svg
                  className="ms-3 size-5 animate-spin text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              )}
            </button>
          </div>
        </div>
      ) : (
        <div className="h-screen flex flex-col items-center justify-center space-y-10 p-6 rounded-lg w-full">
          <img
            src={selectedCenter.logo}
            alt={selectedCenter.name}
            className="h-20 w-auto"
          />
          <div>
            <h1 className="font-somarSemibold text-center text-2xl">
              {t.rateTitle}
            </h1>
            <h1 className="font-somarSemibold text-center text-2xl">
              {selectedCenter.name}
            </h1>
          </div>
          <button
            onClick={() => setstartedRate(true)}
            className="font-somarSemibold bg-[#B29566] rounded-xl p-2 px-24 lg:px-32 text-white text-xl"
          >
            {t.startButton}
          </button>
        </div>
      )}
    </div>
  );
}
